import { render, staticRenderFns } from "./VerifyMessage.vue?vue&type=template&id=fd39b892&scoped=true&"
import script from "./VerifyMessage.vue?vue&type=script&lang=js&"
export * from "./VerifyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd39b892",
  null
  
)

export default component.exports